<!--
 * @Author: MoBai
 * @Date: 2022-02-09 12:40:24
 * @LastEditTime: 2022-02-09 14:19:01
 * @LastEditors: MoBai
-->
<template>
  <div class="rightBottom">
    <div v-for="(item, index) in list" :key="index" class="list-item">
      <img :src="`/static/images/cockpit/${item.imgUrl}.png`" alt="" />
      <div>
        <div class="value">
          <countTo
            :startVal="0"
            :endVal="item.value"
            :decimals="item.imgUrl === 'serviceTotal' ? 1 : 0"
            :duration="1500"
          />
        </div>
        <div class="title">{{ item.name }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import countTo from 'vue-count-to'
export default {
  name: 'Bottom',
  components: { countTo },
  data() {
    return {
      list: [
        { value: 400, name: '申领总金额(万元)', imgUrl: 'applyTotal' },
        { value: 334, name: '订单总个数（个）', imgUrl: 'orderTotal' },
        { value: 299, name: '申领企业数（家）', imgUrl: 'applyEnt' },
        {
          value: 293.9,
          name: '兑付总金额（万元）',
          imgUrl: 'serviceTotal'
        }
      ]
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
.rightBottom {
  width: 100%;
  height: 100%;
  color: rgba(255, 255, 255, 100);
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  padding-left: 0.2rem;
  .list-item {
    width: 50%;
    height: 50%;
    display: flex;
    align-items: center;
    img {
      width: 0.5rem;
      height: 0.5rem;
      display: grid;
      margin-right: 0.15rem;
    }
  }
  .value {
    font-size: 0.3rem;
  }
  .title {
    font-size: 0.16rem;
  }
}
</style>
